export default __webpack_public_path__ + "static/media/avatar_45.7fb9177b.png";